import { RequestMethod } from "lib/api-types";
import { baseApiUrl } from "redux/reducers/settings";

const baseUrl = baseApiUrl ;

export const authApi = {
  AdminLogin: {
    actionName: "ADMIN_LOGIN",
    controllerName: `${baseUrl}users/userlogin`,
    requestMethod: RequestMethod.POST,
    // requestBodyType: RequestBodyType.TABLE_FORM_DATA,
  },



  GetOrganizationConfiguration: {
    actionName: "GET_ORGANIZATION_CONFIGURATION",
    controllerName: `${baseUrl}appconfiguration/appconfiguration/getbydomain`,
    requestMethod: RequestMethod.GET,
  },

    GetAdminPermissionList: {
    actionName: "GET_ADMIN_PERMISSION_LIST",
    controllerName: `${baseUrl}users/adminrole/view`,
    requestMethod: RequestMethod.GET,
  },
      ResetUserPassowrdDefault: {
    actionName: "RESET_USER_PASSWORD_DEFAULT",
    controllerName: `${baseUrl}users/set-user-password/{userID}`,
    requestMethod: RequestMethod.POST,
  },
    DeleteTrainee: {
    actionName: 'DELETE_TRAINEE',
    controllerName: `${baseUrl}users/delete-trainee/{traineeId}`,
    requestMethod: RequestMethod.DELETE
  },
  

};